import { Professional, ProfessionalFormationTypeEnum } from '@medprev-web-app/api-graphql-client';

import { mapSearchApiRating } from '@/app/(main)/(pages)/_services/search-api/map-search-api-rating.util';
import { SearchApiProfessional, SearchApiRating } from '@/app/(main)/(pages)/_types/search-api-response.type';

export function mapSearchApiProfessional(
  professional: SearchApiProfessional,
  rating: SearchApiRating | null,
): Professional {
  return {
    id: professional.id,
    slug: professional.slug ?? '',
    name: professional.name,
    honorific: professional.honorific ?? null,
    avatar: professional.avatar ?? null,
    avatarLarge: professional.avatarLarge ?? null,
    description: professional.description ?? null,
    followUp: professional.followUp ?? null,
    minAge: professional.minAge ?? null,
    maxAge: professional.maxAge ?? null,
    languageAndAccessibility: professional.languageAndAccessibility ?? [],
    treatments: professional.treatments ?? [],
    licenses: (professional.licenses ?? []).map((license) => ({
      certificationBodyId: license.certificationBodyId,
      certificationBodyInitials: license.certificationBodyInitials,
      certificationBodyName: license.certificationBodyName,
      licenseState: license.licenseState,
      licenseRecord: license.licenseRecord,
    })),
    specialties: (professional.specialties ?? []).map((specialty) => ({
      id: specialty.id,
      name: specialty.name,
      isDisplayed: specialty.isDisplayed ?? false,
      specialistQualificationRecord: specialty.specialistQualificationRecord ?? null,
    })),
    professionalFormations: (professional.professionalFormations ?? []).map((formation) => ({
      type: formation.type as ProfessionalFormationTypeEnum,
      description: formation.description ?? null,
      location: formation.location ?? null,
      completionYear: formation.completionYear ? Number(formation.completionYear) : null,
      isMainPostGraduation: formation.isMainPostGraduation ?? false,
    })),
    rating: mapSearchApiRating(rating),
  };
}
